import { render, staticRenderFns } from "./AudiometryInterpretation.vue?vue&type=template&id=198bfa41&"
import script from "./AudiometryInterpretation.vue?vue&type=script&lang=js&"
export * from "./AudiometryInterpretation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports